/**
 * Where a new table goes relative to the paragraph the model anchored it on.
 * The model chooses, because from a cell paragraph both readings are real:
 * a table inside that cell, or a table after the table that holds it.
 */
import { z } from "zod";

/**
 * CASES
 *   - "after_paragraph" -> right after the named paragraph; inside its cell when the paragraph is a cell, so the new table nests
 *   - "after_table"     -> after the outermost table holding the named cell paragraph, behind a separating paragraph
 */
export const tablePlacementSchema = z.enum(["after_paragraph", "after_table"]);
export type TablePlacement = z.infer<typeof tablePlacementSchema>;
